import { useEffect, useRef } from "react";
import { connect, useDispatch } from "react-redux";
import {
  getCurrentCompanyAusIqIqCashAsync,
} from "features/company/companySlice";
import WaterfallChart from "~/Common/WaterfallChart/WaterfallChart";
import { Box, Flex, Heading, Spinner, Text } from "theme-ui";
import { Icon } from "assets/Icon";
import { useTranslation } from "react-i18next";

const mapStateToProps = (state) => ({
  company: state.companies?.currentCompany,
  companies: state.companies,
});

const IqCash = ({ company, companies }) => {
  const dispatch = useDispatch();
  const prevAsxRef = useRef();
  const { t } = useTranslation();

  const { iqCash, iqCashStatus } = companies?.currentCompanyExtras?.ausIq ?? {};

  useEffect(() => {
    const asx = company?.asx;
    if (!asx) return;

    const asxChanged = prevAsxRef.current !== asx;

    if (iqCashStatus === "idle" || asxChanged) {
      dispatch(getCurrentCompanyAusIqIqCashAsync(asx));
    }

    prevAsxRef.current = asx;
  }, [company?.asx, dispatch, iqCashStatus]);

  function buildWaterfallFromQuarter(q) {
    const initial = Number(q.cash_and_cash_equivalents_at_beginning_of_period || 0);
    const end = Number(q.cash_and_cash_equivalents_at_end_of_period || 0);

    const steps = [
      { label: "Financing", value: Number(q.net_cash_from_financing_activities_consolidated || 0) },
      { label: "Operating", value: Number(q.net_cash_from_operating_activities_consolidated || 0) },
    ];

    const knownTotal = steps.reduce((sum, s) => sum + s.value, 0);
    const netOther = end - (initial + knownTotal);
    steps.push({ label: "Net Other", value: netOther });

    return { initial, steps, final: end };
  }

  const { initial, steps, final } = buildWaterfallFromQuarter(iqCash || {});

  const emptyTemplate = (
    <Box px={2}>
        <Flex sx={{
            py: 3,
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column'
        }}>
            <Icon icon="dollar-thin" color="tealDark" mb={'28px'} width="84px" />
            <Heading variant="h2" sx={{ fontSize: ['28px','36px'], textAlign: 'center' }}>{t('No cash flow data available')}</Heading>
            <Text mt={1} variant="subtext">{t('Please check back later.')}</Text>
        </Flex>
    </Box>
  )

  if (iqCashStatus === "loading") {
    return (
      <Flex
        sx={{
          flexDirection: "column",
        }}
      >
        <Spinner variant="styles.spinner" mx={"auto"} mt={4} />
      </Flex>
    );
  }

  return (
    <>
      {iqCash ? 
        <WaterfallChart initial={initial} steps={steps} final={final} reportDate={iqCash?.report_date} />
        : emptyTemplate}
    </>
  );
};

export default connect(mapStateToProps)(IqCash);
